import { Service } from "vue-typedi";
import { EventSourceConfiguration, EventSourceHandler } from "@/helpers/EventSourceHandler";
import { EventBus } from "@/helpers/EventBus";
import { PreparationOrdersEvent } from "@/model/events/PreparationOrdersEvent";
import {SerializationHelper} from "@/helpers/SerializationHelper";

@Service()
export class PreparationEventsService {
  private static readonly PREPARATION_ENDPOINT: string = "/preparation";
  private static readonly STORE_ID: string = "storeId";

  private ordersEventSource: OrdersEventSourceHandler;

  public watchOrders() {
    const siteNumber = sessionStorage.getItem(PreparationEventsService.STORE_ID);
    if (!siteNumber) {
      return;
    }

    if (this.ordersEventSource && this.ordersEventSource.watchedSite !== siteNumber) {
      this.unwatchOrders();
    }

    this.ordersEventSource = new OrdersEventSourceHandler(siteNumber);

    const eventsApi: ApiConfigurationWithKey | ApiConfigurationWithKeyRef = window.configuration?.events;

    const url: URL = new URL(eventsApi.url + PreparationEventsService.PREPARATION_ENDPOINT);
    url.searchParams.set(PreparationEventsService.STORE_ID, siteNumber);

    const eventSourceConfiguration: EventSourceConfiguration = {
      url: url,
      apiKey: "apiKey" in eventsApi ? eventsApi.apiKey : "",
    };

    this.ordersEventSource.subscribeTo(eventSourceConfiguration).catch((error) => {
      console.error("Error : " + error);
    });
  }

  public unwatchOrders() {
    if (!this.ordersEventSource) {
      return;
    }

    this.ordersEventSource.unsubscribe();
    this.ordersEventSource = null;
  }
}

class OrdersEventSourceHandler extends EventSourceHandler {
  public readonly watchedSite: string;

  constructor(watchedSite: string) {
    super("preparation-orders");
    this.watchedSite = watchedSite;
  }

  protected onMessage(me: MessageEvent<any>) {
    if (!me?.data) {
      return;
    }

    const eventBody = SerializationHelper.toInstance(new PreparationOrdersEvent(), me.data);
    if (eventBody != null && !eventBody.isKeepAlive) {
      EventBus.$emit(EventBus.ORDERS_LIST_SERVER_UPDATE, eventBody);
    }
  }
}
